import { render } from "./JoinOurCommunity.vue?vue&type=template&id=11db7b7c"
import script from "./JoinOurCommunity.vue?vue&type=script&lang=js"
export * from "./JoinOurCommunity.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__